import { useContext } from 'react';
import AppContext from '../../../AppContext';
import HeaderHelmet, { HeaderHelmetProps } from '../../SubSectionHeader/HeaderHelmet';
import styles from './LineOfBusiness.module.css';

interface LineOfBusinessHeaderProps {
  helmet: HeaderHelmetProps;
  showReturnOnRevenue?: boolean;
  showLossRatio?: boolean;
  showExpenseRatio?: boolean;
}

export default function LineOfBusinessHeader({
  helmet,
  showReturnOnRevenue,
  showLossRatio,
  showExpenseRatio
}: LineOfBusinessHeaderProps) {
  const { showBenchmark, year } = useContext(AppContext);

  function displayHeader(year: number, label: string) {
    return (
      <>
        <h5 className="column_align_right">
          {year} {label}
        </h5>
        <h5 className="column_align_right">
          {year - 1} {label}
        </h5>
      </>
    );
  }

  function displayEmpty() {
    return (
      <>
        <h5 aria-hidden="true"></h5>
        <h5 aria-hidden="true"></h5>
      </>
    );
  }

  return (
    <div className={`${styles.container} ${showBenchmark ? '' : styles.collapse}`}>
      <HeaderHelmet {...helmet} />
      <h5 className="column_align_right">% Change</h5>
      {displayHeader(year, 'Net Premium')}
      <h5 className="column_align_right">% Change</h5>
      {displayHeader(year, 'Net Operating G(L)')}
      {showReturnOnRevenue
        ? displayHeader(year, 'Return On Revenue')
        : showLossRatio
        ? displayHeader(year, 'Loss Ratio')
        : displayEmpty()}
      {showExpenseRatio ? displayHeader(year, 'Expense Ratio') : displayEmpty()}
    </div>
  );
}
